import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getImgFileKey, getTokenDataArea2025, saveMediaFileArea2025 } from '@src/services/api';
import { Toast, SpinLoading } from 'antd-mobile';
import { getlocal, setlocal } from '@src/utils/index';
import { area } from '@src/utils/area';

window.URL = window.URL || window.webkitURL || window.mozURL;

const UploadPic = ({ name, changeInputHandle, updateId, updateSuccess, languages }) => {
    const [url, setUrl] = useState('');
    const [uploadState, setUploadState] = useState(1);
    const fileRef = useRef();
    const flieWhiteList = ['jpeg', 'png', 'gif', 'jpg'];

    const setImgBase64Url = (file) => {
        const img = new Image();

        img.onload = () => {
            const zipWidth = 240;
            const zipHeight = 240;
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            canvas.width = zipWidth;
            canvas.height = zipHeight;
            // 核心JS就这个
            context.drawImage(img, 0, 0, zipWidth, zipHeight);
            const dataURL = canvas.toDataURL();

            setUrl(dataURL);

            setlocal(`area${name}FormBase64Url`, dataURL);
        };
        img.src = URL.createObjectURL(file);
    };

    const resetShow = () => {
        const formImageBase64Url = getlocal(`area${name}FormBase64Url`);
        const imgKey = getlocal('areaformData')?.[name] || updateId;

        if (formImageBase64Url && imgKey) {
            setUrl(formImageBase64Url);
        }
    };

    useEffect(() => {
        resetShow();
    }, [updateSuccess]);

    useEffect(async () => {
        const picFileDom = fileRef.current;

        picFileDom.addEventListener('change', async () => {
            // todo限制类型和尺寸 图片20M 视频200M
            const formData = new FormData();
            const file = picFileDom.files[0];
            const fileType = file.type.toLocaleLowerCase().split('/');
            const fileSize = file.size;
            const maxFileSize = 20971520; // 20M转换成b

            // 文件格式校验
            if (!flieWhiteList.includes(fileType.pop())) {
                Toast.show({
                    content: area[languages].photo.waring2,
                });

                return false;
            }

            // 文件大小校验
            if (fileSize > maxFileSize) {
                Toast.show({
                    content: area[languages].photo.waring1,
                });

                return false;
            }

            setUploadState(2);
            // 第一步获取token
            const result = await getTokenDataArea2025(name);
            const tokenList = result?.data?.token_list;
            const transaction_id = result?.data?.transaction_id;
            const { url, token } = tokenList.pop();

            formData.append('token', token);
            formData.append('file', file);
            // 第二步上传文件
            const fileResult = await getImgFileKey(url, formData);
            const fileKey = fileResult?.data?.key || '';

            // 第三步存入表单
            await saveMediaFileArea2025(name, {
                transaction_id,
                img: fileKey,
            });

            setImgBase64Url(file);

            // 第四步将transaction_id传入必填字段
            changeInputHandle(name, transaction_id);
            setUploadState(3);
        });
    }, []);

    // const surveyEndHandle = () => {
    //     alert('报名已结束');
    // };

    return (
        <>
            {uploadState === 2 && (
                <div className={styles.loadingBox}>
                    <SpinLoading color="#CE6400" />
                </div>
            )}
            <div className={styles.formImageBox}>
                {url ? (
                    <div className={styles.formImageUpload}>
                        <img className={styles.formImageUploadPic} src={url} />
                        <div className={styles.formImageUploadInfo}>{area[languages].photo.reLoadText}</div>
                    </div>
                ) : (
                    <div className={styles.formImageUploadButton} style={{ backgroundImage: `url(${area[languages].photo.defaultImage})` }} />
                )}
                <input
                    ref={fileRef}
                    accept={flieWhiteList.map((item) => `image/${item}`).join(',')}
                    className={styles.formImageUploadInput}
                    // capture="filesystem"
                    type="file"
                />
            </div>
        </>
    );
};

UploadPic.propTypes = {
    name: PropTypes.string,
    changeInputHandle: PropTypes.func,
    updateId: PropTypes.string,
    updateSuccess: PropTypes.bool,
    languages: PropTypes.string,
};

export default errorBoundary(UploadPic);
